import "./styles.scss";



type Props = {
  title: string;
}

function PageHeader({
  title
}: Props) {
  return (
    <div className="page-header">
      <h1 className="header-title">
        {title}
      </h1>
    </div>
  );
}

export default PageHeader;